var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId: '6100000093',
      dataClass: 2,
      name: '用户角色修改',
      parentId: 'USER_ID',
      parentName: '用户角色管理',
      parentPath: '/system/user/userRoleManagement',
      addForm: {
        USER_ID: _vm.$route.query.USER_ID,
      },
      addClick: _vm.addClick
    }}}),_c('wx-select',{ref:"wxSelect",attrs:{"visible":_vm.selector,"select":{
      searchslottitle: '请选择角色',
      searchslotId: 105, // 选择器ID
      searchslotkey: { ID: 'ID',TEAM_NAME: 'TEAM_NAME', $TEAM_NAME: 'TEAM_NAME' },
      multiple: true, // 多选
      loadObj: {
        filterWhere: _vm.$route.query.TEAM_NAME, // 搜索框搜索条件
        colname: 'TEAM_NAME' // 搜索列名
      }
    }},on:{"update:visible":function($event){_vm.selector=$event},"return":_vm.fn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }